"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileToolbarWrapper = void 0;
var React = require("react");
var classNames = require("classnames");
var ResponsiveButtonBar_1 = require("components/ResponsiveButtonBar");
var MobileDefaultButtons_1 = require("../../MobileDefaultButtons");
var MobileFileSelectedButtons_1 = require("../../MobileFileSelectedButtons");
var Icon_1 = require("components/Icon");
var sok_ui_1 = require("@caddigital/sok-ui");
var Modal_1 = require("../Modal");
var MobileToolbarWrapper = function (props) {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement(ResponsiveButtonBar_1.ResponsiveButtonBar, { verticalButtonLayout: true, forceMobileStyle: true },
            props.selectedItems.length > 0 ? (React.createElement(MobileFileSelectedButtons_1.default, { isManySelections: props.selectedItems.length > 1, addItemsToCart: props.addItemsToCart, showButtons: props.isGranoAdmin || props.folderPath.length > 0, selectedItems: props.selectedItems, setRemoveIsOpen: props.setRemoveIsOpen, openOverlay: props.openOverlay, setScheduledRemoveIsOpen: function () {
                    var firstSelectedItem = props.selectedItems[0];
                    (firstSelectedItem === null || firstSelectedItem === void 0 ? void 0 : firstSelectedItem.type) === 'FOLDER' &&
                        props.openScheduledDeletionDialog(firstSelectedItem);
                }, setArchiveSubprojectIsOpen: props.setArchiveSubprojectIsOpen, archiveStatusMeta: props.archiveStatusMeta })) : (React.createElement(MobileDefaultButtons_1.default, { openNewFolderDialog: props.openNewFolderDialog, toggleUploadModal: props.toggleUploadModal, showButtons: props.isGranoAdmin || props.folderPath.length > 0, currentProject: props.currentProject, currentFolder: props.currentFolder, currentBid: props.currentBid, toggleFileReportModal: props.toggleFileReportModal, openCopyFromProjectOverlay: props.openCopyFromProjectOverlay, setCreateSubprojectIsOpen: props.setCreateSubprojectIsOpen })),
            !props.currentBid && (React.createElement(sok_ui_1.Button, { color: "dark-gray", text: "Follow", icon: React.createElement(Icon_1.Icon, { className: classNames('fa-bell', {
                        active: ((_a = props.currentFolder) === null || _a === void 0 ? void 0 : _a.notifications).email
                    }) }), onClick: function () {
                    return props.currentFolder &&
                        props.currentProject &&
                        props.openNotifications([props.currentFolder], props.currentProject.name);
                } }))),
        React.createElement(Modal_1.Modals, __assign({}, props))));
};
exports.MobileToolbarWrapper = MobileToolbarWrapper;
